import forgotPassword from '../../../forgotPwd/forgotPassword.vue';
import Login from '../../component/commonPages/Login.vue';
export default [
  {
    path: '/r3login', // TODO: 临时的，给r3登录留一个口子
    component: Login
  },
  {
    path: '/sso/frontCallback',
    component: Login
  },
  {
    path: '/sso/loginCallback',
    component: Login
  },
  {
      path: '/forgotPassword', //忘记密码
      component: forgotPassword
  }
];
